<script setup lang="ts">
import { useMapgl } from '@/js/vue/composable/mapgl.ts';
import { onMounted } from 'vue';

const { center } = defineProps<{
  center: number[]
}>();
const mapInstance = defineModel<mapgl.Map>('map');
const marker = defineModel<mapgl.Marker>('marker');
const { loadAPI, createMap, createMarker } = useMapgl();

onMounted(async () => {
  await loadAPI();
  const map = createMap('double-gis-map', {
    center,
    zoom: 10,
  });

  mapInstance.value = map;
  marker.value = createMarker(map, center);
});
</script>

<template>
  <div id="double-gis-map" />
</template>

<style scoped lang="scss">
#double-gis-map {
  width: 100%;
  height: 600px;
}
</style>
